/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TeamsControllerFindProjectsInTeamQueryResponse, TeamsControllerFindProjectsInTeamPathParams, TeamsControllerFindProjectsInTeamQueryParams, TeamsControllerFindProjectsInTeam401, TeamsControllerFindProjectsInTeam403, TeamsControllerFindProjectsInTeam404 } from "../../models/teamsController/TeamsControllerFindProjectsInTeam";

function getTeamsControllerFindProjectsInTeamUrl(id: TeamsControllerFindProjectsInTeamPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/teams/${id}/projects` as const }  
  return res
}

/**
 * @summary Get all projects in a team
 * {@link /api/v1/teams/:id/projects}
 */
export async function teamsControllerFindProjectsInTeam(id: TeamsControllerFindProjectsInTeamPathParams["id"], params?: TeamsControllerFindProjectsInTeamQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TeamsControllerFindProjectsInTeamQueryResponse, ResponseErrorConfig<TeamsControllerFindProjectsInTeam401 | TeamsControllerFindProjectsInTeam403 | TeamsControllerFindProjectsInTeam404>, unknown>({ method : "GET", url : getTeamsControllerFindProjectsInTeamUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}